// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ComponentIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ComponentIcon" ref={forwardedRef} {...props}>
      <path d="M8.042 15.09 10 17.05l1.958-1.96L10 13.134zm2.663 3.369-.076.067a.996.996 0 0 1-1.258 0L9.295 18.46l-2.663-2.663-.068-.077a1 1 0 0 1 0-1.258l.068-.075 2.663-2.663a.997.997 0 0 1 1.41 0l2.663 2.663.068.075a.997.997 0 0 1-.068 1.335z" />
      <path d="m2.951 10 1.959 1.96L6.868 10 4.91 8.042zm2.663 3.368L5.54 13.436a.996.996 0 0 1-1.259 0l-.075-.068-2.663-2.663-.068-.076a1 1 0 0 1 0-1.258l.068-.075 2.663-2.663a.997.997 0 0 1 1.41 0l2.662 2.663.069.075a.997.997 0 0 1-.069 1.334z" />
      <path d="m13.132 10 1.958 1.959L17.05 10l-1.96-1.958zm2.663 3.368-.076.068a.996.996 0 0 1-1.258 0l-.076-.068-2.663-2.663-.068-.076a1 1 0 0 1 0-1.259l.068-.075 2.663-2.663a.997.997 0 0 1 1.41 0l2.663 2.663.068.075a.997.997 0 0 1-.068 1.335z" />
      <path d="M8.042 4.91 10 6.868l1.958-1.958L10 2.952zm2.663 3.368-.076.067a.996.996 0 0 1-1.258 0L9.295 8.278 6.632 5.615 6.564 5.538a1 1 0 0 1 0-1.258l.068-.075 2.663-2.663a.997.997 0 0 1 1.41 0l2.663 2.663.068.075a.997.997 0 0 1-.068 1.335z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ComponentIcon = /* @__PURE__ */ Object.assign(
  ComponentIconComponent,
  { displayName: 'ComponentIcon' },
);
